import { request } from 'apis/core';
import { ApiResponse } from 'shared/types';

import { EmailCertificationRequest, verifyRequestCodeRequest } from '../model';

export const requestEmailCertification = async (payload: EmailCertificationRequest): Promise<ApiResponse> => {
  const data = await request.post<ApiResponse>('/auth/admin/email-certification', payload);
  return data;
};

export const verifyRequestCode = async (payload: verifyRequestCodeRequest): Promise<ApiResponse<string>> => {
  const data = await request.post<ApiResponse<string>>('/auth/admin/verify-code', payload);
  return data;
};
